'use strict';
import angular from 'angular';
import './scripts/association.history.ctrls';
import './scripts/association.history.services';

import associationHistoryHtmlUrl from './views/associationHistory.html';
import placementManagerHtmlUrl from './views/placementManager.html';

angular.module('associationHistory', ['association.history.ctrls', 'association.history.services'])

    .config(['$stateProvider', function ($stateProvider) {

        $stateProvider
            .state('associationHistory', {
                parent: 'layout',
                url: '/admin/associationHistory/:id?fromPage?lineItemId',
                templateUrl: associationHistoryHtmlUrl,
                controller: 'AssociationHistoryController'
            })
            .state('placementManager', {
                parent: 'layout',
                url: '/admin/placementManager/:fromPage?orderId?lineItemId',
                templateUrl: placementManagerHtmlUrl,
                controller: 'PlacementManagerController'
            })
    }]);
